import { render, staticRenderFns } from "./course_introduce.vue?vue&type=template&id=e141faa4&scoped=true"
import script from "./course_introduce.vue?vue&type=script&lang=js"
export * from "./course_introduce.vue?vue&type=script&lang=js"
import style0 from "./course_introduce.vue?vue&type=style&index=0&id=e141faa4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e141faa4",
  null
  
)

export default component.exports